



















































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bContainer from 'bootstrap-vue/es/components/layout/container';
import bImg from 'bootstrap-vue/es/components/image/img';
import bLink from 'bootstrap-vue/es/components/link/link';

import { Collection } from '@/models';

import PriceBlock from '@/components/PriceBlock.vue';

const FeaturedCollectionProps = Vue.extend({
  props: {
    heading: {
      type: String,
    },
    collection: {
      type: Object as () => Collection,
      required: true,
    },
  },
});

@Component({
  components: {
    PriceBlock,
    bContainer,
    bImg,
    bLink,
  },
})
export default class FeaturedCollection extends FeaturedCollectionProps { }

